import React, { useEffect,useState } from "react";
import { Button, Empty, Pagination } from "antd";
import { useNavigate } from "react-router-dom";

import useJDStore from "../../store/jd.store";
import Table from "../Table";

import "./jdsPriority.scss";
import Filter from "../filter";

export default function JdsPriority(props) {
  const navigate = useNavigate();

  const { getJdsPriorityPagination, jdsPriorityPagination,jdsPriorityCountPagination } = useJDStore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };    

  const customerList = [
    "Sr. No.",    
    "Client",
    "TA",
    "JD Todays",
    "JD Urgent",
    "JD High Priority",
    "JD Normal Priority",
    "JD Low Priority",
    "JD Open",
    "JD Hold Due to FB Pending",
    "JD Hold Due to Pipeline",
    "JD Hold Due to Selection",
    "JD Closed",
    "JD Expired",
  ];

 const isValid = (value) => {
    if (value === undefined ||  value =="" || value == null){
       return false
    }
    return true
 }
 
 const jdsDetailData = jdsPriorityPagination?.map((item, idx) => {
    var ta = item.clients?.clienttalist
    return {
                id: idx + 1 + ((currentPage-1)*pageSize),
                clientName: item.clients?.clientname,
                taName: ta?.taname,
                tpr: isValid(ta?.totaljdst) ? ta?.totaljdst : "-",              
                upr: isValid(ta?.totaljdsu) ? ta?.totaljdsu : "-",              
                hpr: isValid(ta?.totaljdsh) ? ta?.totaljdsh : "-",
                npr: isValid(ta?.totaljdsn) ? ta?.totaljdsn : "-",              
                lpr: isValid(ta?.totaljdsl) ? ta?.totaljdsl : "-",
                jdsopen: isValid(ta?.totaljdsopen) ? ta?.totaljdsopen : "-",
                jdsholdfb: isValid(ta?.totaljdsholdfb) ? ta?.totaljdsholdfb : "-",
                jdsholdp: isValid(ta?.totaljdsholdp) ? ta?.totaljdsholdp : "-",
                jdsholds: isValid(ta?.totaljdsholds) ? ta?.totaljdsholds : "-",
                jdsclosed: isValid(ta?.totaljdsclosed) ? ta?.totaljdsclosed : "-",   
                jdsexpired: isValid(ta?.totaljdsexpired) ? ta?.totaljdsexpired  : "-",             
    };
  });

  return (
    <div className="jds-wrapper">
      <div className="jds-result-title">
       ({jdsPriorityCountPagination || 0}){" "} Results Found 
      </div>
      <div>
      <Filter
        filtername = {"getJdsPriorityPagination"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}  
        initClient={"All"}  
        pageNo = {currentPage}
        pageSize ={pageSize}            
        enableDuration
        enableCustomers    
        enableTAs 
        disableCustomersOptionInternal         
        handleFilter={getJdsPriorityPagination}
        pageHandler = {setCurrentPage}  
      />
      <div></div>
      </div>      
      {jdsPriorityPagination?.length > 0 ? (
           <Table
            isClickable={false}
            isJDPage={false}
            titleList={customerList}
            data={jdsDetailData}
          columnWidth={[
            50, 200, 100, 100, 100, 100, 100, 100, 100, 200, 200, 200, 100,100
          ]}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={jdsPriorityCountPagination}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />        
    </div>
  );
}
